import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import CasinoRoundedIcon from '@mui/icons-material/CasinoRounded';
import DialogContent from '@mui/material/DialogContent';
import { useCallback } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { ALL_PANEL_BUTTON_PROPERTIES } from '../../panels/rightPanelButton';
import { thunkOpenDirectMessagesToPlayer } from '../../redux/actions/directMessagesActions';
import { thunkShowPlayerInfo } from '../../redux/actions/playerInfoActions';
import { thunkPlaceSideBet } from '../../redux/actions/sideBetsActions';
import { selectSideBettingState } from '../../redux/selectorFns';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { ColumnIconButton } from '../columnIconButton';
import { OpenModalContainer } from '../openModalContainer';
const BUTTONS_CONTAINER_CSS = css `
  display: flex;
  flex-flow: row wrap;
  gap: 12px;
  justify-content: center;
`;
export const PlayerQuickActionsModal = ({ player, onClose }) => {
    const sideBettingState = useAppSelector(selectSideBettingState);
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickViewPlayerInfo = useCallback(() => {
        dispatch(thunkShowPlayerInfo(player, socketSend));
        onClose();
    }, [dispatch, onClose, player, socketSend]);
    const onClickDirectMessages = useCallback(() => {
        dispatch(thunkOpenDirectMessagesToPlayer(player, socketSend));
        onClose();
    }, [dispatch, onClose, player, socketSend]);
    const onClickSideBet = useCallback(() => {
        dispatch(thunkPlaceSideBet(player.id, socketSend));
        onClose();
    }, [onClose, player.id, socketSend, dispatch]);
    const PlayerInfoSvgIcon = ALL_PANEL_BUTTON_PROPERTIES.playerInfo.shownIcon;
    const DirectMessagesSvgIcon = ALL_PANEL_BUTTON_PROPERTIES.directMessages.shownIcon;
    return (_jsx(OpenModalContainer, { maxWidth: 'xs', title: player.name, onClose: onClose, ariaLabel: `${player.name} Quick Actions`, children: _jsx(DialogContent, { children: _jsxs("div", { css: BUTTONS_CONTAINER_CSS, children: [_jsx(ColumnIconButton, { label: 'Player Info', icon: PlayerInfoSvgIcon, onClick: onClickViewPlayerInfo }), _jsx(ColumnIconButton, { label: 'Direct Messages', icon: DirectMessagesSvgIcon, onClick: onClickDirectMessages }), sideBettingState !== 'off' && (_jsx(ColumnIconButton, { label: 'Side Bet', icon: CasinoRoundedIcon, onClick: onClickSideBet, isDisabled: sideBettingState === 'disabled' }))] }) }) }));
};
